import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Dropdown } from 'primereact/dropdown';
import { FaSpinner } from 'react-icons/fa';
import SummerNote from '../../TaskCreator/CreatorTask/SummerNote';
import { Calendar } from 'primereact/calendar';
import { useDispatch } from 'react-redux';
import { AddNotificationPop } from '../../../Redux/Actions/AdminNotificationList';
const PopNotificationModel = (props) => {
    const [date, setDate] = useState(null);
    const dispatch = useDispatch()
    const [imageUrl, setImageUrl] = useState(null)
    const [data, setData] = useState({
        "heading": "",
        "subheading": "",
        "description": "",
        "expired": "",
        "image": "",
    })
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        console.log(name)
        if (name === "image") {
            console.log(files[0])
            if (files.length === 0) return;
            const objectURL = URL.createObjectURL(files[0]);
            setImageUrl(objectURL)
            setData({ ...data, [name]: files[0] })
        } else {
            setData({ ...data, [name]: value })
        }
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        props.setLoader({
            ...props.loader,
            save: true
        })
        const formData = new FormData();
        formData.append("heading", data.heading);
        formData.append("subheading", data.subheading);
        formData.append("description", data.description);
        formData.append("expiry_date", date?.toLocaleDateString('en-CA') || null);
        formData.append("image", data.image);
        dispatch(AddNotificationPop("add-popup-notification", formData, props.setLoader, props.loader, props.fetchMessage, props.handleClose))
    }

    return (
        <>
            <Modal className="theme-modal forgotpass-moda creator_new_task link_submit_modal" show={props.show} onHide={props.handleClose} backdrop="static" centered>
                <Modal.Header closeButton style={{ borderBottom: "0" }}>
                </Modal.Header>
                <Modal.Body className='pt-0'>
                    <div className='d-flex align-items-center modal-btn justify-content-between'>
                        {/* <span><MdOutlineArrowBackIos /></span>  */}
                        <h3 className="m-auto" style={{ fontSize: "25px" }}>Add Notification
                        </h3>
                        {/* <span onClick={props.handleClose}><RxCross1 /></span>    */}

                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-card mt-4 ">
                            <div className='account-block mb-0 px-1 py-1'>
                                <div className='submission_wrap submission_bg mt-3 mb-3'>
                                    <label htmlFor="" class="form-label">Heading
                                    </label>
                                    <input style={{ padding: "8px" }}
                                        className="border-0 w-100"
                                        type="text"
                                        placeholder="Enter heading"
                                        value={data.heading}
                                        onChange={handleChange}
                                        name="heading"
                                        required

                                    />
                                </div>
                                <div className='submission_wrap submission_bg mt-3 mb-3'>
                                    <label htmlFor="" class="form-label">Sub Heading
                                    </label>
                                    <input style={{ padding: "8px" }}
                                        className="border-0 w-100"
                                        type="text"
                                        placeholder="Enter sub heading"
                                        value={data.subheading}
                                        onChange={handleChange}
                                        name="subheading"
                                        required

                                    />
                                </div>
                                <div className='submission_wrap submission_bg mt-3 mb-3'>
                                    <label htmlFor="" class="form-label">Description

                                    </label>
                                    <SummerNote state={data} setState={setData} editing={true} />
                                </div>
                                <div className='submission_wrap submission_bg mt-3 mb-3'>
                                    <label htmlFor="" class="form-label">Expire Date

                                    </label>
                                    <Calendar placeholder='Date' value={date} onChange={(e) => setDate(e.value)} />
                                </div>
                                <div className='submission_wrap submission_bg mt-3 mb-3'>
                                    <label htmlFor="" class="form-label">Image


                                    </label>
                                    <input style={{ padding: "8px" }}
                                        className="border-0 w-100"
                                        type="file"
                                        accept=".jpg, .jpeg, .png, .gif"
                                        placeholder="Enter sub heading"
                                        // value={data.image}
                                        onChange={handleChange}
                                        name="image"

                                    />
                                    {imageUrl && <img src={imageUrl} alt="Preview" style={{ width: "100px", height: "100px", marginTop: "10px" }} />}
                                </div>
                            </div>
                            <div className="link_btn text-end my-2">
                                <button className='theme-btn saveBtn ms-auto me-2 d-flex' type="submit" style={{ padding: "8px 24px" }}>Submit {props.loader.save ? <FaSpinner className="spin ms-1" /> : null}</button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default PopNotificationModel